import api from './axiosConfig';

export const invoiceApi = {
  createInvoice: (data) => api.post('/v1/invoices', data),
  getInvoices: (customerId) => {
    let url = '/v1/invoices';
    if (customerId) url += `?customerId=${customerId}`;
    return api.get(url);
  },
  getInvoiceDetails: (id) => api.get(`/v1/invoices/${id}`),
  updateInvoice: (id, data) => api.put(`/v1/invoices/${id}`, data),
  getWalkInCustomerByPhone: (phone) => api.get(`/v1/invoices/walkin/${phone}`)
};
